import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { DownloadTearsheetState } from "@tSurya/Store/Data/DownloadTearSheetState";
import { FilterModalState } from "@tSurya/Store/Data/FilterMenuState";

import { Draft } from "immer";

const initialState: DownloadTearsheetState = {
    downloadtearsheet: false,
};

const reducer = {
    "Custom/ProductList/SetTearsheetDownloadLoading": (
        draft: Draft<DownloadTearsheetState>,
        action: { result: boolean },
    ) => {
        draft.downloadtearsheet = action.result;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
